module.exports = __webpack_public_path__ + "media/packs/images/bell-lg-2da88cc073b4d83c53cc525a26074b16.svg";